import styles from "./toast-container.module.scss";

import { createPortal } from "react-dom";
import { useDispatch } from "react-redux";
import cn from "classnames";
import { motion, AnimatePresence } from "framer-motion";

import Toast from "../Toast/Toast";
import { storeActions, useToastList } from "src/store/toaster";

const animationConfig = {
  toast: {
    layout: true,
    initial: { y: -56, scale: 0.9 },
    animate: { y: 0, scale: 1 },
    exit: { opacity: 0, scale: 0.7, transition: { duration: 0.1 } },
  },
};

export default function ToastContainer() {
  const dispatch = useDispatch();

  const toasts = useToastList();

  return createPortal(
    <div className={styles.container}>
      <div className={cn(styles.stack, styles.top, styles.middle)}>
        <AnimatePresence>
          {toasts.map((toastConfig) => (
            <motion.div key={toastConfig.id} {...animationConfig.toast}>
              <Toast
                {...toastConfig}
                onDismiss={(id) => {
                  dispatch(storeActions.remove(id));
                  toastConfig.onDismiss && toastConfig.onDismiss(id);
                }}
              />
            </motion.div>
          ))}
        </AnimatePresence>
      </div>
    </div>,
    document.getElementById("portal") as HTMLElement
  );
}
